import { marked } from 'marked';

// Configuration unique : pas de breaks markdown automatiques sur les retours simples,
// pas de mangling pour les emails (pas pertinent ici), gfm activé pour les listes/tableaux.
marked.setOptions({
  gfm: true,
  breaks: true,
});

/**
 * Convertit un texte markdown en HTML inline pour rendu via dangerouslySetInnerHTML.
 * Sécurité : Claude est la seule source, on lui interdit le HTML brut côté prompt.
 * On retire quand même les balises <script> par précaution.
 */
export function renderMarkdown(input: string | null | undefined): string {
  if (!input) return '';
  try {
    const out = marked.parse(String(input), { async: false }) as string;
    // Strip script tags (defense in depth)
    return out.replace(/<script[\s\S]*?<\/script>/gi, '');
  } catch {
    return escapeHtml(String(input));
  }
}

/** Inline only : pas de <p>, juste le contenu (utile dans titles, KPI labels…). */
export function renderMarkdownInline(input: string | null | undefined): string {
  if (!input) return '';
  try {
    const out = marked.parseInline(String(input), { async: false }) as string;
    return out.replace(/<script[\s\S]*?<\/script>/gi, '');
  } catch {
    return escapeHtml(String(input));
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!)
  );
}
